// extracted by mini-css-extract-plugin
module.exports = {"bmn5fjc":"bmn5fjc","small":"small","inset":"inset"};